import Vue from 'vue'
import Vuex from 'vuex'

import {mutations} from './mutations'
import {actions} from './actions'
import {getters} from './getters'
import MenuItem from "@/models/MenuItem";

Vue.use(Vuex);

export const state = {
  /** Menu**/
  selectedMenuItem: MenuItem.parseDataFromObject({id: 0, name:'Home'}),
};

const store = {
  strict: false,
  state,
  mutations,
  actions,
  getters,
};

// create the store
const vuexStore = new Vuex.Store(store);

export default vuexStore;
